import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api } from '../lib/api.js';

/** Choix d'un nouveau mot de passe, depuis le lien reçu par email. */
export function Reinitialiser() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const [fait, setFait] = useState(false);

  async function soumettre(evenement) {
    evenement.preventDefault();
    setErreur(null);
    setEnvoi(true);

    try {
      await api.post('/auth/reset', { token, password: motDePasse });
      setFait(true);
      // Le temps de lire la confirmation avant d'atterrir sur la connexion.
      setTimeout(() => navigate('/connexion', { replace: true }), 2500);
    } catch (echec) {
      setErreur(echec.message);
      setEnvoi(false);
    }
  }

  return (
    <main className="page page--etroite">
      <section className="verre">
        <h1>Nouveau mot de passe</h1>

        {fait ? (
          <>
            <p>
              Mot de passe modifié. Toutes les sessions ouvertes ont été fermées,
              y compris sur vos autres appareils.
            </p>
            <p className="bascule">
              <Link to="/connexion">Se connecter</Link>
            </p>
          </>
        ) : (
          <form onSubmit={soumettre} noValidate>
            <div className="champ">
              <label htmlFor="password">Choisissez un mot de passe</label>
              <input
                id="password"
                type="password"
                autoComplete="new-password"
                value={motDePasse}
                onChange={(e) => setMotDePasse(e.target.value)}
                required
              />
              <p className="aide">Au moins 10 caractères.</p>
            </div>

            {erreur && (
              <p className="erreur" role="alert">
                {erreur}
              </p>
            )}

            <button className="bouton" type="submit" disabled={envoi}>
              {envoi ? 'Enregistrement…' : 'Enregistrer'}
            </button>

            <p className="bascule">
              <Link to="/mot-de-passe-oublie">Demander un nouveau lien</Link>
            </p>
          </form>
        )}
      </section>
    </main>
  );
}
